import { BackgroundData } from "../background/background.component";
import { OfferCardData } from "../offers/offer-card-data.model";
import { SnakeCaseSegment } from "projects/common/services/flights.service";

export interface UserFavoriteData {
  product: FavoriteProductEnum;
  background_module?: BackgroundData;
  show_header: boolean;
  social_id: string;
  favorites: UserFavoriteCardData[];
  show_delete_btn?: boolean;
  show_alert_btn?: boolean;
  sorted_by?: UserFavoriteSortBy;
  max_items?: number;
  product_icon?: string;
  cards_type?: FavoriteCardTypeEnum;
}

export enum UserFavoriteSortBy {
  PRODUCT = 'PRODUCT',
  DESTINATION = "DESTINATION",
  DESTINATION_NAME = "DESTINATION_NAME",
  PRODUCT_DESTINATION_NAME = "PRODUCT_DESTINATION_NAME"
}

export interface UserFavoriteCardData extends OfferCardData {
  external_id: string;
  itineraries: UserFavoriteItinerary[];
  baggage: BaggageInfo;
  airlines: UserFavoriteAirlineInfo[];
  origin: string;
  destination: string;
  product: FavoriteProductEnum;
  details: Characteristic[];
  characteristics?: Characteristic[];
  logo: string;
  overall_rating_text?: string;
}


export type Characteristic = {
  icon: string;
  text: string;
}



export interface UserFavoriteItinerary {
  flight_type: UserFavoriteFlightType;
  text: string;
  from: string;
  to: string;
  check_in_date: string;
  check_in_time: string;
  scale_text: string;
  stops_quantity: number;
  segments: SnakeCaseSegment[];
}

export interface BaggageInfo {
  backpack: boolean;
  carry_on: boolean;
  checked_bag_quantity: number;
}

export interface UserFavoriteAirlineInfo {
  name: string;
  logo_url: string;
}

export enum UserFavoriteFlightType {
  OUTBOUND = 'OUTBOUND',
  RETURN = 'RETURN'
}

export enum UserFavoriteTracker {
  OPEN = 'OPEN',
  DELETE = 'DELETE',
  CREATE_ALERT = 'CREATE_ALERT'
}

//--

export enum FavoriteProductEnum {
  FLIGHT = 'FLIGHT',
  ACCOMMODATION = 'ACCOMMODATION',
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  TRANSFER = 'TRANSFER',
  FAVORITE_CTA = 'FAVORITE_CTA',
  EMPTY_CARD = 'EMPTY_CARD'
}

export enum FavoriteCardTypeEnum {
  COMMON = 'COMMON',
  REDUCED = 'REDUCED'
}

export type UserFavoriteCardDataFlights = {
  airlines: UserFavoriteAirlineInfo[];
  itineraries: UserFavoriteItinerary[];
  stay_text?: string,
  baggage: BaggageInfo;
  product: FavoriteProductEnum;
};
